if ($(window).width() > 767) {
  _theme.initSlickSlider(
    $('.searchNoResultCollections'),
    {
      rows: 0,
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      accessibility: true,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        { breakpoint: 1500, settings: { slidesToShow: 5 } },
        { breakpoint: 1300, settings: { slidesToShow: 4, slidesToScroll: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 600, settings: { slidesToShow: 2.5, slidesToScroll: 1 } },
        { breakpoint: 320, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
        { breakpoint: 1, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
      ],
    },
    function () {
      $('.product-item').attr('tabindex', '-1');
    }
  );
}
